import { useQuery } from "@tanstack/react-query";

import type { Settings } from "../models/settings";

import { BaseController } from "./baseController";
import { QUERY_KEYS } from "./queryKeys";

const controller = "Settings";

export function useSettingsQuery() {
	const Get = BaseController.GetFn(controller);

	const { data: settings, isFetching: settingsLoading } = useQuery({
		queryKey: [QUERY_KEYS.Settings],
		queryFn: () => Get<Settings>(""),
	});

	return { settings, settingsLoading };
}
